import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom';
import $ from "jquery";
import _ from 'lodash';
import joshLogo from '../../assets/creator-pro-logo.svg'
import Edit from '../../assets/Edit.svg'
import Downarrow from "../../assets/down_arrow.svg";
import Editicon from "../../assets/edit_profile_icon.svg";
import Helpicon from "../../assets/help-icon.svg";
import fileIcon from "../../assets/file.svg";
import aboutIcon from "../../assets/aboutIcon.svg";
import Logouticon from "../../assets/logout_icon.svg";
import profileImg from "../../assets/profile.png";
import BackArrowWhite from "../../assets/back-arrow-white.svg";
import { onLogOut } from '../../services';
import { PROFILE_DETAILS, REGISTER_DETAILS } from '../../redux/action_type';
import EditProfile from "../editProfile/EditProfile";
import AboutUs from '../aboutUs/AboutUs';
import { useDispatch, useSelector } from 'react-redux';
import { EmailShareButton } from 'react-share';
import { truncate } from '../../utils/common';
import Close_white from "../../assets/white-close.svg";
import aboutSlider1 from "../../assets/about-1.svg";
import aboutSlider2 from "../../assets/about-2.svg";
import aboutSlider3 from "../../assets/about-3.svg";
import aboutSlider4 from "../../assets/about-4.svg";
import leftCoin from "../../assets/left-coin.svg";
import rightCoin from "../../assets/right-coin.svg";
import OwlCarousel from 'react-owl-carousel';
import { LoginSocialApple, LoginSocialFacebook, LoginSocialGoogle } from "reactjs-social-login";
import aboutIocon2 from "../../assets/google-about.svg";
import aboutIocon3 from "../../assets/facebook-about.svg";
import { encryptResponse } from "../../utils/common";
import { onSendOTP, onSendOTPVerify, onSocialVerify } from "../../services";
import { onJustReducerUpdate } from "../../redux/action";
import { useToast } from '../../toast';
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import CreatorForm from '../sprint-4/creator-form/CreatorForm';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { detectIncognito } from "detectincognitojs";

function Header() {
    const storageValue = localStorage.getItem("clientID")
    const history = useHistory();
    const profileDetails = useSelector((state) => state.profileDetails)
    const [provider, setProvider] = useState(null)
    const [profile, setProfile] = useState(null)
    const myRef = useRef(null)
    const dispatch = useDispatch()
    const client_id = JSON.parse(storageValue)?.client_id || ""
    const clientIDs = useSelector((state) => state.clientID || {})
    const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
    const toast = useToast();
    const[deviceId,setDeviceId]=useState("")
    const[incognito,setIncognito]=useState(false)
    const handleProfileDetails = useSelector((state) => state.handleProfileDetails)
    const linkedPersonalDetails = useSelector((state) => state.linkedPersonalDetails)

    const checkLogin = async () => {
        try {
            const fpPromise = FingerprintJS.load()
            fpPromise
                .then(fp => fp.get())
                .then(result => {
                    const visitorId = result.visitorId
                    // setDeviceId(visitorId)
                    detectIncognito().then((result) => {
                        // setIncognito(result.isPrivate)
                        onHandleLogout(visitorId,result.isPrivate)
                    }).catch((err) => console.log(false));

                })
        } catch (error) {
            console.log(false);
        }
    }

    const onHandleLogout = (deviceId,incognito) => {
        let authData = localStorage.getItem(REGISTER_DETAILS)
        authData = JSON.parse(authData)
        if (!authData) {
            return
        }
        // checkLogin()
        let payload={
            is_incognito:incognito,
            device_id:deviceId
        }
        onLogOut(payload).then((res) => {
            if (res.status) {
                $("#logout-popup").modal("hide");
                history.push("/")
                window?.google.accounts.id.disableAutoSelect();
                googleLogout();
                window?.FB?.logout()
                localStorage.removeItem(REGISTER_DETAILS)
                dispatch(onJustReducerUpdate({}, PROFILE_DETAILS))
            }
        })
    }

    const onLogoClick = () => {
        // if (profileDetails?.cp_creators?.length === 0 || !profileDetails?.cp_creators?.length) {
        //     history.push("/link-account");
        // } else {
        history.push("/dashboards");
        // }
    }
    const onLoginResolve = (provider, id_token, code_token = "") => {
        let payload = {
            "client_id": client_id || clientIDs?.client_id || "",
            "country_code": "",
            "mobile_no": "",
            "otp": "",
            "token": encryptResponse(id_token),
            "user_auth_type": provider?.toUpperCase()
        }
        if (provider?.toUpperCase() === "APPLE") {
            payload = { ...payload, authorizationCode: code_token }
        }
        onSocialVerify(payload).then((res) => {
            if (res.status) {
                if (payload?.user_auth_type === "GOOGLE") {
                    window?.google?.accounts?.id?.revoke(res?.data?.gid, done => {
                        console.log("revoke", done.error);
                    });
                }
                $("#aboutus-modal").modal("hide");
                dispatch(onJustReducerUpdate(res.data, REGISTER_DETAILS))
                localStorage.setItem(REGISTER_DETAILS, JSON.stringify(res.data))
                toast.open("Login Successful")
                $("#login-popup").modal("hide");
                history.push("/dashboards");
            }
        })
    }

    const onPersonalDetails = () => {
        if (linkedPersonalDetails?.linked) {
            $("#creator-pop-new").modal("show")
            return
        }
        toast.open("Please link the account first", "warn")
        return
    }

    return (
        <>
            <div className='header-wrap flex-justify' id="header-container">
                {
                    window.location.pathname === "/social-performance" ?
                        <div className='d-flex'>
                            <img onClick={onLogoClick} className='josh-logo cursor-pointer header-back showint' src={BackArrowWhite} alt="" />
                            <img onClick={onLogoClick} className='josh-logo cursor-pointer' src={joshLogo} alt="" />
                        </div>
                        : <img onClick={onLogoClick} className='josh-logo cursor-pointer' src={joshLogo} alt="" />
                }
                <div className="dropdown use-info-div">
                    {window.location.pathname === "/" ?
                        <a className="dropdown-toggle" data-toggle="modal" data-target="#aboutus-modals">
                            About Us </a> : null}
                    {window.location.pathname === "/" ? <a className="dropdown-toggle">
                        <EmailShareButton
                            onClick={(_, link) => {
                                window.location.href = `mailto:${process.env.REACT_APP_HELP_MAIL}?body=${window.location.origin}`;
                            }}>
                            Help
                        </EmailShareButton>
                    </a> : null}
                    {!_.isEmpty(profileDetails) && handleProfileDetails === false && window?.location?.pathname != "/" &&
                        <button
                            className="dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <img src={profileDetails?.user_image ? profileDetails?.user_image : profileImg} alt="" />
                            <span>{truncate(`${profileDetails?.name || ""}`, 30)}</span>
                            <img className="downarrow" src={Downarrow} alt="" />
                        </button>}
                    {!_.isEmpty(profileDetails) ? <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        {!_.isEmpty(profileDetails?.cp_creators) && profileDetails?.cp_creators?.[0]?.is_linked && <a className="dropdown-item" onClick={() => history.push("/account-authentication")}>
                            <img src={Edit} alt="" /> Manage Account
                        </a>}
                        {typeof window?.newsHuntAction === 'undefined' ? <a data-toggle="modal" data-target="#edit-profile" className="dropdown-item" href="javascript:void(0);">
                            <img src={Editicon} alt="" /> Edit Profile
                        </a> : null}
                        <a className="dropdown-item" onClick={() => onPersonalDetails()}>
                            <img src={fileIcon} alt="" /> Personal Details
                        </a>
                        <a className="dropdown-item" data-toggle="modal" data-target="#aboutus-modal">
                            <img src={aboutIcon} alt="" /> About Us
                        </a>
                        <a className="dropdown-item">
                            <EmailShareButton
                                onClick={(_, link) => {
                                    window.location.href = `mailto:${process.env.REACT_APP_HELP_MAIL}?body=${window.location.origin}`;
                                }}
                                id="email-share" className='whatsapp-share w-100 d-flex' url={window.location.origin}>
                                <img src={Helpicon} alt="" /> Help
                            </EmailShareButton>
                        </a>
                        {typeof window?.newsHuntAction === 'undefined' ? <a className="dropdown-item" data-toggle="modal" data-target="#logout-popup" >
                            <img src={Logouticon} alt="" /> Logout
                        </a> : null}
                    </div> : null}
                </div>
                {/* Logout Popup Start Here */}
                <div
                    className="modal fade logout-popup-wrap"
                    id="logout-popup"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                        <div className="modal-content   ">
                            <div className="modal-body ">
                                <div className='logout-card'>
                                    <p>Are you sure you want to logout?</p>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className='common-btn'>
                                    <button onClick={checkLogin}>Logout</button>
                                    <button data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Logout Popup End Here */}
                {/* About Us Popup HTML Start Here  */}
                <div
                    className="modal fade about-us-overlay"
                    id="aboutus-modals"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    // data-backdrop="static" data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup aboutus-popup" role="document">
                        <div className="modal-content   ">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    About Us
                                </h5>
                                <button type="button" className="close" data-dismiss="modal">
                                    <span aria-hidden="true">
                                        <img src={Close_white} alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="aboutus-content">
                                            <div className="coin-right"><img src={leftCoin} alt="" /></div>
                                            <div className="coin-left "><img src={rightCoin} alt="" /></div>
                                            <p>How do I earn money using my social accounts? </p>
                                            <span>CreatorPro is the solution. Link your social accounts and get access to exciting monetization opportunities.</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="about-OwlCarousel">
                                            <OwlCarousel
                                                className="owl-theme"
                                                loop={true}
                                                margin={20}
                                                nav={false}
                                                autoWidth={false}
                                                autoplay={true}
                                                responsive={{
                                                    0: {
                                                        items: 1,
                                                        stagePadding: 0,
                                                    },
                                                    600: {
                                                        items: 1,
                                                        stagePadding: 30,
                                                    },
                                                    1000: {
                                                        items: 1,
                                                    },
                                                }}
                                            >
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider1} alt="" />
                                                            <p>45+ performance metrics tracked in one place </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider2} alt="" />
                                                            <p>10000+ brands are waiting for colloborations </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider3} alt="" />
                                                            <p>Connect more accounts and monitor your performance</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="item">
                                                    <div className="aboutus-slider-wrap">
                                                        <div className="aboutus-slider-card">
                                                            <img src={aboutSlider4} alt="" />
                                                            <p>Choose from 20000+ affiliate products</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </OwlCarousel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="footer-text">
                                    Join 10,000+ creators who are using Creator PRO now!
                                    <div className="login-otp-wrap">
                                        <div className="common-btn">
                                            <button data-toggle="modal" data-target="#login-popup" data-dismiss="modal" >Login with OTP</button>
                                        </div>
                                        <div className="or-class"> <span>OR</span> </div>
                                        <ul>
                                            <li>
                                                <GoogleLogin
                                                    theme="filled_blue"
                                                    shape="circle"
                                                    type="icon"
                                                    auto_select={false}
                                                    onSuccess={(credentialResponse) => {
                                                        console.log("123credentialResponse", credentialResponse);
                                                        onLoginResolve("GOOGLE", credentialResponse?.credential)
                                                    }}
                                                    onError={() => {
                                                        console.log('Login Failed');
                                                    }}
                                                />
                                            </li>
                                            <li>
                                                <LoginSocialFacebook
                                                    appId={process.env.REACT_APP_FB_APP_ID}
                                                    fieldsProfile={
                                                        'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                                                    }
                                                    redirect_uri={REDIRECT_URI}
                                                    onResolve={({ provider, data }) => {
                                                        console.log("123provider, data ", provider, data)
                                                        setProvider(provider)
                                                        setProfile(data)
                                                        onLoginResolve(provider, data?.accessToken)
                                                    }}
                                                    onReject={err => {
                                                        console.log(err);
                                                    }}
                                                >
                                                    <img className="cursor-pointer" src={aboutIocon3} alt="" />
                                                </LoginSocialFacebook>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* About Us Popup HTML Start Here  */}
                <EditProfile />
                <AboutUs />
            </div>
            <CreatorForm />
        </>
    )
}

export default Header